import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiSpbKpiResponse,
  SaktiSpbListResponse,
  SaktiSpbDetailResponse,
  SaktiFilters,
} from '../types';

const buildSpbParams = (filters: SaktiFilters & { page?: number; limit?: number }) => {
  const params: Record<string, string | number> = {
    date: filters.date,
  };

  if (filters.company_id) params.company_id = filters.company_id;
  if (filters.estate_id) params.estate_id = filters.estate_id;
  if (filters.division_id) params.division_id = filters.division_id;
  if (filters.page) params.page = filters.page;
  if (filters.limit) params.limit = filters.limit;

  return params;
};

export class SaktiSpbApiService {
  static async getKpi(filters: SaktiFilters): Promise<SaktiSpbKpiResponse> {
    const response = await api.get<SaktiSpbKpiResponse>(SAKTI_API_CONFIG.SPB_KPI_PATH, {
      params: buildSpbParams(filters),
    });
    return response.data;
  }

  static async getList(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiSpbListResponse> {
    const response = await api.get<SaktiSpbListResponse>(SAKTI_API_CONFIG.SPB_LIST_PATH, {
      params: buildSpbParams(filters),
    });
    return response.data;
  }

  static async getDetail(id: string): Promise<SaktiSpbDetailResponse> {
    const response = await api.get<SaktiSpbDetailResponse>(SAKTI_API_CONFIG.SPB_DETAIL_PATH(id));
    return response.data;
  }

  static async editSpb(id: string, payload: any): Promise<any> {
    const response = await api.patch(SAKTI_API_CONFIG.SPB_EDIT_PATH(id), payload);
    return response.data;
  }
}

export default SaktiSpbApiService;
